import { BoundingBox, CategorizedData, DisaggregatedMetric, GeoDetails, GeoTag, Metric, MetricMetadata } from "../services/types";
import { indicatorsEnv, metricsEnv } from "./environment";

// SVG Imports
import populationSvg from '../assets/lakewood/overview/pop-blue.svg';
import disabledSvg from '../assets/lakewood/overview/disabled.svg';
import foreignSvg from '../assets/lakewood/overview/globe.svg';
import limitedEnglishSvg from '../assets/lakewood/overview/limited-english.svg';

import homeownershipSvg from '../assets/lakewood/economy/homeownership-rate.svg';
import medianHouseholdSvg from '../assets/lakewood/economy/median-household-income.svg';
import nonAutoCommutersSvg from '../assets/lakewood/economy/non-auto-commuters.svg';
import povertyRateSvg from '../assets/lakewood/economy/poverty-rate.svg';
import qualityJobsSvg from '../assets/lakewood/economy/quality-jobs.svg';
import unemploymentSvg from '../assets/lakewood/economy/unemployment.svg';

import transitSvg from '../assets/lakewood/accessibility/transit-accessibility.svg';
import internetSvg from '../assets/lakewood/accessibility/internet.svg';
import householdVehicleSvg from '../assets/lakewood/accessibility/household-vehicle.svg';
import roadQualitySvg from '../assets/lakewood/accessibility/road-quality.svg';
import retailSvg from '../assets/lakewood/accessibility/retail.svg';
import voterSvg from '../assets/lakewood/accessibility/voter.svg';
import librarySvg from '../assets/lakewood/accessibility/library.svg';
import foodSvg from '../assets/lakewood/accessibility/food.svg';
import arterialSvg from '../assets/lakewood/accessibility/arterial.svg';
import pedTrailsSvg from '../assets/lakewood/accessibility/ped-bike.svg';
import residentParksSvg from '../assets/lakewood/accessibility/resident-parks.svg';
import qualityParksSvg from '../assets/lakewood/accessibility/quality-parks.svg';

import educationSvg from '../assets/lakewood/education/education.svg';
import gradSvg from '../assets/lakewood/education/grad-rate.svg';
import testRateSvg from '../assets/lakewood/education/test-rate.svg';
import mobilitySvg from '../assets/lakewood/education/mobility.svg';
import kinderSvg from '../assets/lakewood/education/kindergarten.svg';

import trafficSvg from '../assets/lakewood/environment/traffic.svg';
import treeSvg from '../assets/lakewood/environment/tree.svg';
import heatIslandSvg from '../assets/lakewood/environment/heat-island.svg';
import dieselSvg from '../assets/lakewood/environment/diesel.svg';
import pmSvg from '../assets/lakewood/environment/pm.svg';
import toxicSvg from '../assets/lakewood/environment/toxic-releases.svg';
import ozoneSvg from '../assets/lakewood/environment/ozone.svg';

import homeValueSvg from '../assets/lakewood/livability/med-home-value.svg';
import costBurdenedSvg from '../assets/lakewood/livability/cost-burdened.svg';
import selfRatedSvg from '../assets/lakewood/livability/health.svg';
import uninsuredSvg from '../assets/lakewood/livability/uninsured.svg';
import crashesSvg from '../assets/lakewood/livability/crashes.svg';
import lifeExpectancySvg from '../assets/lakewood/livability/life.svg';

//SVGR Imports
import populationIcon from '../assets/svgr/lakewood/overview/pop-blue.svg?react';
import disabledIcon from '../assets/svgr/lakewood/overview/disabled.svg?react';
import foreignIcon from '../assets/svgr/lakewood/overview/globe.svg?react';
import limitedEnglishIcon from '../assets/svgr/lakewood/overview/limited-english.svg?react';

import homeownershipIcon from '../assets/svgr/lakewood/economy/homeownership-rate.svg?react';
import medianHouseholdIcon from '../assets/svgr/lakewood/economy/median-household-income.svg?react';
import nonAutoCommutersIcon from '../assets/svgr/lakewood/economy/non-auto-commuters.svg?react';
import povertyRateIcon from '../assets/svgr/lakewood/economy/poverty-rate.svg?react';
import qualityJobsIcon from '../assets/svgr/lakewood/economy/quality-jobs.svg?react';
import unemploymentIcon from '../assets/svgr/lakewood/economy/unemployment.svg?react';

import transitIcon from '../assets/svgr/lakewood/accessibility/transit-accessibility.svg?react';
import internetIcon from '../assets/svgr/lakewood/accessibility/internet.svg?react';
import householdVehicleIcon from '../assets/svgr/lakewood/accessibility/household-vehicle.svg?react';
import roadQualityIcon from '../assets/svgr/lakewood/accessibility/road-quality.svg?react';
import retailIcon from '../assets/svgr/lakewood/accessibility/retail.svg?react';
import voterIcon from '../assets/svgr/lakewood/accessibility/voter.svg?react';
import libraryIcon from '../assets/svgr/lakewood/accessibility/library.svg?react';
import foodIcon from '../assets/svgr/lakewood/accessibility/food.svg?react';
import arterialIcon from '../assets/svgr/lakewood/accessibility/arterial.svg?react';
import pedTrailsIcon from '../assets/svgr/lakewood/accessibility/ped-bike.svg?react';
import residentParksIcon from '../assets/svgr/lakewood/accessibility/resident-parks.svg?react';
import qualityParksIcon from '../assets/svgr/lakewood/accessibility/quality-parks.svg?react';

import educationIcon from '../assets/svgr/lakewood/education/education.svg?react';
import gradIcon from '../assets/svgr/lakewood/education/grad-rate.svg?react';
import testRateIcon from '../assets/svgr/lakewood/education/test-rate.svg?react';
import mobilityIcon from '../assets/svgr/lakewood/education/mobility.svg?react';
import kinderIcon from '../assets/svgr/lakewood/education/kindergarten.svg?react';

import trafficIcon from '../assets/svgr/lakewood/environment/traffic.svg?react';
import treeIcon from '../assets/svgr/lakewood/environment/tree.svg?react';
import heatIslandIcon from '../assets/svgr/lakewood/environment/heat-island.svg?react';
import dieselIcon from '../assets/svgr/lakewood/environment/diesel.svg?react';
import pmIcon from '../assets/svgr/lakewood/environment/pm.svg?react';
import toxicIcon from '../assets/svgr/lakewood/environment/toxic-releases.svg?react';
import ozoneIcon from '../assets/svgr/lakewood/environment/ozone.svg?react';

import homeValueIcon from '../assets/svgr/lakewood/livability/med-home-value.svg?react';
import costBurdenedIcon from '../assets/svgr/lakewood/livability/cost-burdened.svg?react';
import selfRatedIcon from '../assets/svgr/lakewood/livability/health.svg?react';
import uninsuredIcon from '../assets/svgr/lakewood/livability/uninsured.svg?react';
import crashesIcon from '../assets/svgr/lakewood/livability/crashes.svg?react';
import lifeExpectancyIcon from '../assets/svgr/lakewood/livability/life.svg?react';


// #region Organization Metric Mapping
const organizationMetrics: { [orgId: number]: any[] } =
{ 
    // Lakewood
    1:
    [
        {
            name: "Overview",
            ids: [248, 245, 244, 246],
            order: [
                [248, 246],
                [244, 245]
            ],
            charts: [
                {
                    name: "raceethnicity",
                    id: null // Still needs to be added
                },
                {
                    name: "agegender",
                    id: null // Add age and gender
                },
                {
                    name: "immigration",
                    id: 1291 // Add Countries of Immigration
                }
            ]
        },
        {
            name: "Accessibility",
            ids: [4, 44, 45, 46, 47, 48, 49, 61, 62, 63, 64, 65],
            order: [
                [45, 64, 48, 47],
                [46, 65, 63, 62],
                [61, 4, 49]
            ],
            charts: []
        },
        {
            name: "Livability",
            ids: [57, 58, 59, 60, 78, 79, 80, 81, 82],
            order: [
                [78, 80, 82, 81, 57, 79],
            ],
            charts: [
                {
                    name: "crimerisk",
                    id: 56
                },
            ]
        },
        {
            name: "Education",
            ids: [51, 52, 53, 54, 71],
            order: [
                [71, 51, 52, 53, 54],
            ],
            charts: []
        },
        {
            name: "Economy",
            ids: [50, 66, 67, 68, 69, 70],
            order: [
                [66, 69, 67, 70, 50, 68],
            ],
            charts: []
        },
        {
            name: "Environment",
            ids: [55, 72, 73, 74, 75, 76, 77],
            order: [
                [75, 55, 77, 72, 74, 76, 73],
            ],
            charts: []
        }
    ]
};

// precisionMapping - maps metricId's to the desired number of significant figures for formatting metric values
export const precisionMapping: { [metricId: number]: number } = {
    248: 0,
    245: 0,
    244: 0,
    246: 0,
    45: 0, 
    63: 0, 
    64: 0, 
    44: 0, 
    49: 0, 
    62: 0, 
    65: 0, 
    46: 0,
    48: 2,
    47: 2,
    61: 0,
    4: 2,
    78: 0, 
    80: 0, 
    82: 0, 
    81: 0, 
    57: 0, 
    79: 2,
    71: 2, 
    51: 0, 
    52: 0, 
    53: 0, 
    54: 0,
    66: 2, 
    69: 0, 
    67: 0, 
    70: 0, 
    50: 0, 
    68: 0,
    75: 2, 
    55: 0, 
    77: 2, 
    72: 2, 
    74: 2, 
    76: 2, 
    73: 2,
    1291: 0,
    1293: 0,
};

// Identify metrics included in the index
export const indexMetricIds: number[] = [4, 44, 45, 46, 47, 62, 63, 64, 57, 78, 79, 80, 81, 51, 52, 53, 54, 71, 50, 66, 67, 68, 69, 55, 72, 73, 74, 75, 77];


const svgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Lakewood
    1: {
        45: transitSvg, 
        63: internetSvg,
        64: householdVehicleSvg,
        44: roadQualitySvg,
        49: retailSvg,
        62: voterSvg,
        65: librarySvg,
        46: foodSvg,
        48: arterialSvg,
        47: pedTrailsSvg,
        61: residentParksSvg,
        4: qualityParksSvg,
        248: populationSvg,
        245: disabledSvg,
        244: foreignSvg,
        246: limitedEnglishSvg,
        66: qualityJobsSvg, // Quality Jobs Index
        69: unemploymentSvg, // Unemployment Rate
        67: medianHouseholdSvg, // Median Household Income
        70: homeownershipSvg, // Homeownership Rate 
        50: nonAutoCommutersSvg, // Non-Auto Commuters
        68: povertyRateSvg, // Poverty Rate
        71: educationSvg,
        51: gradSvg,
        52: testRateSvg,
        53: mobilitySvg,
        54: kinderSvg,
        75: trafficSvg,
        55: treeSvg,
        77: heatIslandSvg,
        72: dieselSvg,
        74: pmSvg,
        76: toxicSvg,
        73: ozoneSvg,
        78: homeValueSvg, 
        80: costBurdenedSvg,
        82: selfRatedSvg,
        81: uninsuredSvg,
        57: crashesSvg,
        79: lifeExpectancySvg,
    },
};

// There are svgs that need to be included in the pdf that are excluded in the dashboard
const pdfSvgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Lakewood
    1: {
        45: transitSvg, 
        63: internetSvg,
        64: householdVehicleSvg,
        44: roadQualitySvg,
        49: retailSvg,
        62: voterSvg,
        65: librarySvg,
        46: foodSvg,
        48: arterialSvg,
        47: pedTrailsSvg,
        61: residentParksSvg,
        4: qualityParksSvg,
        248: populationSvg,
        245: disabledSvg,
        244: foreignSvg,
        246: limitedEnglishSvg,
        66: qualityJobsSvg, // Quality Jobs Index
        69: unemploymentSvg, // Unemployment Rate
        67: medianHouseholdSvg, // Median Household Income
        70: homeownershipSvg, // Homeownership Rate 
        50: nonAutoCommutersSvg, // Non-Auto Commuters
        68: povertyRateSvg, // Poverty Rate
        71: educationSvg,
        51: gradSvg,
        52: testRateSvg,
        53: mobilitySvg,
        54: kinderSvg,
        75: trafficSvg,
        55: treeSvg,
        77: heatIslandSvg,
        72: dieselSvg,
        74: pmSvg,
        76: toxicSvg,
        73: ozoneSvg,
        78: homeValueSvg, 
        80: costBurdenedSvg,
        82: selfRatedSvg,
        81: uninsuredSvg,
        57: crashesSvg,
        79: lifeExpectancySvg,
    },
};

const svgrMap: { [orgId: number]: { [key: number]: React.FC<React.SVGProps<SVGSVGElement>> }} =
{
    // Lakewood
    1: {
        45: transitIcon, 
        63: internetIcon,
        64: householdVehicleIcon,
        44: roadQualityIcon,
        49: retailIcon,
        62: voterIcon,
        65: libraryIcon,
        46: foodIcon,
        48: arterialIcon,
        47: pedTrailsIcon,
        61: residentParksIcon,
        4: qualityParksIcon,
        248: populationIcon,
        245: disabledIcon,
        244: foreignIcon,
        246: limitedEnglishIcon,
        66: qualityJobsIcon, // Quality Jobs Index
        69: unemploymentIcon, // Unemployment Rate
        67: medianHouseholdIcon, // Median Household Income
        70: homeownershipIcon, // Homeownership Rate 
        50: nonAutoCommutersIcon, // Non-Auto Commuters
        68: povertyRateIcon, // Poverty Rate
        71: educationIcon,
        51: gradIcon,
        52: testRateIcon,
        53: mobilityIcon,
        54: kinderIcon,
        75: trafficIcon,
        55: treeIcon,
        77: heatIslandIcon,
        72: dieselIcon,
        74: pmIcon,
        76: toxicIcon,
        73: ozoneIcon,
        78: homeValueIcon, 
        80: costBurdenedIcon,
        82: selfRatedIcon,
        81: uninsuredIcon,
        57: crashesIcon,
        79: lifeExpectancyIcon,
    },
};

// There are svgs that need to be included in the pdf that are excluded in the dashboard
const pdfSvgrMap: { [orgId: number]: { [key: number]: React.FC<React.SVGProps<SVGSVGElement>> }} =
{
    // Lakewood
    1: {
        45: transitIcon, 
        63: internetIcon,
        64: householdVehicleIcon,
        44: roadQualityIcon,
        49: retailIcon,
        62: voterIcon,
        65: libraryIcon,
        46: foodIcon,
        48: arterialIcon,
        47: pedTrailsIcon,
        61: residentParksIcon,
        4: qualityParksIcon,
        248: populationIcon,
        245: disabledIcon,
        244: foreignIcon,
        246: limitedEnglishIcon,
        66: qualityJobsIcon, // Quality Jobs Index
        69: unemploymentIcon, // Unemployment Rate
        67: medianHouseholdIcon, // Median Household Income
        70: homeownershipIcon, // Homeownership Rate 
        50: nonAutoCommutersIcon, // Non-Auto Commuters
        68: povertyRateIcon, // Poverty Rate
        71: educationIcon,
        51: gradIcon,
        52: testRateIcon,
        53: mobilityIcon,
        54: kinderIcon,
        75: trafficIcon,
        55: treeIcon,
        77: heatIslandIcon,
        72: dieselIcon,
        74: pmIcon,
        76: toxicIcon,
        73: ozoneIcon,
        78: homeValueIcon, 
        80: costBurdenedIcon,
        82: selfRatedIcon,
        81: uninsuredIcon,
        57: crashesIcon,
        79: lifeExpectancyIcon,
    },
};

// #endregion



// getMetricGroupIds - get the metric id values for a specific grouping 
export const getMetricGroupIds = (name: string) => {

    let ids = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            ids = group.ids;
        }
    }

    return ids;
}

// Store our organization Id where we can access it later
export var orgId: number = 1;
export const setOrgId = (id: number) => {
    orgId = id;
}

// Store our overlapping county fips codes for BLS and TRS data queries
export var countyId: string[] = [];
export const setCountyIds = (id: string[]) => {
    countyId = id;
}
export const getCountyIds = () => {
    return countyId;
}

// Store our bounding box so we can access it later
export let boundingBox: BoundingBox | null = null;
export const setBoundingBox = (bb: BoundingBox) => {
    boundingBox = bb;
}

// Store our excludeIds so we can access them later
export let excludeIds: string[] | null = null;
export const setExcludeIds = (ids: string[]) => {
    excludeIds = ids;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgMap = (id: number) => {
    let svg = "";
    if(svgMap[orgId] != undefined){
        svg = svgMap[orgId][id];
    }
    return svg;
}

// getPdfSvgMap - get our pdf svg mapping for the given organization and metric id
export const getPdfSvgMap = (id: number) => {
    let svg = "";
    if(pdfSvgMap[orgId] != undefined){
        svg = pdfSvgMap[orgId][id];
    }
    return svg;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgrMap = (id: number): React.FC<React.SVGProps<SVGSVGElement>> | undefined => {
    if(svgrMap[orgId] != undefined){
        return svgrMap[orgId][id];
    }
    return undefined;
}

// getPdfSvgMap - get our pdf svg mapping for the given organization and metric id
export const getPdfSvgrMap = (id: number): React.FC<React.SVGProps<SVGSVGElement>> | undefined => {
    if(pdfSvgrMap[orgId] != undefined){
        return pdfSvgrMap[orgId][id];
    }
    return undefined;
}

// getMetricGroupOrderIds - get the ordering for a metric group
export const getMetricGroupOrderIds = (name: string) => {
    let orderIds = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            orderIds = group.order;
        }
    }

    return orderIds;
}

// getMetricGroupChartId - get a metric id given the group and chart key
export const getMetricGroupChartId = ( group: string, key: string) => {
    let id = -1;

    if(organizationMetrics[orgId] != undefined){
        const g = organizationMetrics[orgId].find((x: { name: string; }) => x.name === group);
        if(g != undefined){
            
            if(g.charts != undefined){

                const chart = g.charts.find((x: { name: string; }) => x.name === key);
                if(chart != undefined){
                    id = chart.id;
                }
            }
        }
    }

    return id;
}

export const categorizeData = (indicators: DisaggregatedMetric[]) => {

    const categories: { [key: string]: number[] } = {
        Overview: getMetricGroupIds("Overview"),
        Livability: getMetricGroupIds("Livability"),
        Economy: getMetricGroupIds("Economy"), 
        Accessibility: getMetricGroupIds("Accessibility"),
        Education: getMetricGroupIds("Education"),
        Environment: getMetricGroupIds("Environment"),
    };

    // Initialize the categorizedData object dynamically with empty arrays for each category
    const categorizedData: Record<string, Metric[]> = Object.keys(categories).reduce((acc, category) => {
        acc[category] = [];
        return acc;
    }, {} as Record<string, Metric[]>);

    // Categorize the indicators dynamically
    indicators.forEach((item) => {
        Object.keys(categories).forEach((category) => {
            if (categories[category].includes(item.id)) {
                categorizedData[category].push(item);
            }
        });
    });

    return categorizedData;
};

export const fetchMetricCategories = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetriccategories?orgId=${orgId}&environment=${metricsEnv}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadata = async (id: number) => {
    if (!id) {
        console.log('No id provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetricmetadata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id, environment: metricsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadataByOrg = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetadatabyorg`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ orgId, environment: metricsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.log('Error fetching metric metadata:', error);
    }
};

// fetch PercentileDist - get percentile distribution information by org and category
export const fetchPercentileDist = async (orgId: number, category: string) => {
    if (!orgId || !category) {
        console.log('No orgId or category provided to fetch metric percentile distributions');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentiledist?orgId=${orgId}&category=${category}&environment=${indicatorsEnv}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetchPercentileById - get percentile distribution information by metric id
export const fetchPercentileById = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch metric percentile data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentilebymetric?metricId=${metricId}&environment=${indicatorsEnv}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching percentile data:', error);
    }
};

// fetchDistributionData - get distribution data by metric id and selected area
export const fetchDistributionData = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getdistributiondata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchIndicatorBinCount - get indicator data and bin count by metric id and selected area
export const fetchIndicatorBinCount = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getindicatorbincounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchStateData - retreive state data for a selected metric using a prefix state code
export const fetchStateData = async (metricId: number, geoPrefix: string) => {
    if (!metricId || !geoPrefix) {
        console.log('No metricId or geoDetails provided to fetch metric state data');
        return;
    }

    console.log('geoprefix:', geoPrefix);

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoPrefix, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric state data:', error);
    }
};

// fetchNationalData - retreive national data for a selected metric
export const fetchNationalData = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch national metric data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, environment: indicatorsEnv }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching national metric data:', error);
    }
};

export const calculateGeoPrefix = (geoDetails: GeoDetails[]): string => {
    // Flatten the geoIds array
    const geoIds = geoDetails.flatMap(geo => geo.ids);

    // Helper function to get the first two digits of a geoId
    const getGeoPrefix = (geoId: string): string => geoId.substring(0, 2);

    // Count occurrences of each prefix
    const prefixCount: Record<string, number> = {};
    geoIds.forEach(geoId => {
        const prefix = getGeoPrefix(geoId);
        prefixCount[prefix] = (prefixCount[prefix] || 0) + 1;
    });

    // Find the prefix with the highest count
    return Object.entries(prefixCount).reduce((prev, curr) => 
        curr[1] > prev[1] ? curr : prev, ['', 0]
    )[0];
};

// getMissingMetrics - utility function to check for missing metrics on a given dashboard panel
export const getMissingMetrics = (
    tab: string,
    categorizedData: Metric[],
    indicators: DisaggregatedMetric[] | null
  ): string => {
    if (!indicators) return '';
  
    const missingMetrics = indicators?.filter(metric => 
        metric.category?.toLowerCase() === tab.toLowerCase() && 
        !categorizedData.some(data => data.id === metric.id)
    ) || [];    
  
    return missingMetrics.map(metric => metric.name).join(", ");
};

// Helper function to get and sort metrics by category
export const getSortedMetrics = (category: string, categorizedData: CategorizedData) => {
    const orders = getMetricGroupOrderIds(category);

    return orders.map((order: number[]) => 
        categorizedData[category]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};

// Helper function to get and sort metrics by category - Used in PDF metrics display
export const getSortedMetricsPDF = (category: string, categorizedData : {
    category: string;
    metrics: DisaggregatedMetric[];
}[]): DisaggregatedMetric[] => {
    const metrics = categorizedData.find(data => data.category === category)?.metrics || [];
    const orders = getMetricGroupOrderIds(category);
    return orders.flatMap((order: number[]) =>
      metrics
        .filter(metric => order.includes(metric.id))
        .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};
  
// Helper function to get the index metric data
export const getIndexMetricData = (
    category: string, 
    metadata: MetricMetadata[] | null, 
    disaggregatedData: DisaggregatedMetric[]
): { indexMetricId: number; indexMetricData: DisaggregatedMetric | null } => {
    
    const indexMetricId = metadata?.find(
        (metric) => 
            metric.metric_source_type === "index" && 
            metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;

    const indexMetricData = disaggregatedData.find(metric => metric.id === indexMetricId) || null;

    return { indexMetricId, indexMetricData };
};

// Helper function to get the index metric data - Formatted for PDF (MetricModal) use.
export const getIndexMetricDataPDF = (category: string, metadata: MetricMetadata[] | null, disaggregatedData: DisaggregatedMetric[]): DisaggregatedMetric | null => {
    const indexMetricId = metadata?.find(
        (metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;
    return disaggregatedData.find(metric => metric.id === Number(indexMetricId)) || null;
};

